<template>
  <van-popup v-model="showInvoice" round position="bottom" style="height:450px;" @close="doCancel">
    <div class="popup-title">发票</div>
    <van-cell-group  title="发票类型">
      <van-cell :border="false">
        <template #title>
          <van-tag type="danger" round plain size="medium">电子普通发票</van-tag>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group  title="发票抬头">
      <van-cell :border="false" >
        <template >
            <van-radio-group v-model="bodyType" @change="onChangeBodyType" direction="horizontal">
                <van-radio :name="1" checked-color="#ee0a24">个人</van-radio>
                <van-radio :name="2" checked-color="#ee0a24">单位</van-radio>
            </van-radio-group>
        </template>
      </van-cell>
     
      <van-field
        v-if="bodyType == 1"
        v-model="bodyName"
        label="个人名称"
        placeholder="请填写您的姓名"
        placeholder-style = "color:#eb2444;"
        :border="false"
      />
      <van-field
        v-if="bodyType == 2"
        v-model="bodyName"
        label="单位名称"
        placeholder="请填写单位名称"
        placeholder-style = "color:#eb2444;"
        :border="false"
      />
      <van-field
        v-if="bodyType == 2"
        v-model="bodyCode"
        label="纳税人识别号"
        placeholder="请填写纳税人识别号"
        placeholder-style = "color:#eb2444;"
        :border="false"
      />
    </van-cell-group>
    <van-cell-group title="收票人信息" >
      <van-field
        v-model="receiveEmail"
        label="收票人邮箱"
        placeholder="用来接收电子发票邮件"
        :border="false"
      />
    </van-cell-group>
    <div class="bts-bottom">
      <van-row gutter="20">
        <van-col span="12" >
          <van-button round block @click="doCancel"  >取消</van-button>
        </van-col>
        <van-col span="12">
          <van-button round block type="danger" @click="doOk"  >确认</van-button>
        </van-col>
      </van-row>
    </div>
  </van-popup>
</template>

<script>
import { RadioGroup, Radio, CellGroup, Field, Cell, Tag, Popup, Row, Col, Button, Toast } from 'vant';
// import request from '@/utils/request'
export default {
  components: {
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data() {
    return {
      showInvoice: false,
      loading: true,
      bodyType: 1,
      bodyName: '',
      bodyCode: '',
      receiveEmail: ''
    };
  },
  methods: {
    show(){
      this.showInvoice = true
    },
    onChangeBodyType(){
      this.bodyName = ''
      this.bodyCode = ''
    },
    doOk(){
      let bodyType = this.bodyType
      if(!this.bodyName){
        Toast('请填写' + (bodyType == 1 ? '您的名称' : '单位名称'))
        return
      }
      if(bodyType == 2 && !this.bodyCode){
        Toast('请填写纳税人识别号')
        return
      }
      this.$emit('success' , {
        bodyType: this.bodyType,
        bodyName: this.bodyName,
        bodyCode: this.bodyCode,
        receiveEmail: this.receiveEmail
      })
      this.showInvoice = false
    },
    doCancel(){
      this.showInvoice = false
    }
  }
};
</script>

<style lang="less">
  .invoice .van-cell-group__title {
    color: #000000;
  }
</style>
